import { useAppSelector } from '.';
import { selectIsGateUngated } from '../selectors/gate.selectors';
export const useIsUngated = gateName => {
  return useAppSelector(state => selectIsGateUngated(state, {
    gateName
  }));
};